import { render, staticRenderFns } from "./EventHistoryParams.vue?vue&type=template&id=bb50a456"
import script from "./EventHistoryParams.vue?vue&type=script&lang=js"
export * from "./EventHistoryParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports